export const defaultNavData = {
    title: "Greenwood Island Resort",
    links: [
        { id: "navLink1", text: "About Little Andaman", href: "#about" },
        { id: "navLink2", text: "Our Resort", href: "#our-resort" },
        { id: "navLink3", text: "Experiences", href: "#experiences" },
        { id: "navLink4", text: "Gallery", href: "#gallery" },
        { id: "navLink5", text: "Contact Us", href: "#contact" }
    ]
};

export const defaultHeroData = {
    title: "Welcome to Paradise",
    subtitle: "Your subtitle goes here.",
    buttonText: "Explore",
    images: []
};

export const defaultAboutData = {
    heading: "About Us",
    text: "Write your story here...",
    images: []
};

export const defaultResortData = {
    heading: "Our Resort",
    text: "Describe your resort amenities...",
    images: []
};

export const defaultGalleryData = {
    title: "Gallery",
    subtitle: "A glimpse of our world.",
    images: []
};

export const defaultFooterData = {
    aboutText: "About your company.",
    contactTitle: "Contact Us",
    address: "Address Line 1",
    email: "email@example.com",
    phone: "+1 (555) 000-0000",
    copyrightText: "© 2024 Greenwood Island Resort. All rights reserved."
};
